import { HttpInterceptorFn } from '@angular/common/http';
import { SKIP_AUTH } from './skip-auth.context';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { from, switchMap } from 'rxjs';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { AUTHENTICATION_PROVIDER } from '@shared/config';
import { ToastrService } from 'ngx-toastr';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  // if this is not a request to our own api, do not apply this auth flow
  const authProvider = inject(AUTHENTICATION_PROVIDER);

  let withinAuthDomain = false;
  for (const authDomain of authProvider.AUTHENTICATION_DOMAINS) {
    if (req.url.startsWith(authDomain)) {
      withinAuthDomain = true;
    }
  }

  if (!withinAuthDomain) {
    return next(req);
  }

  // if "skip auth" context exists (e.g. login route or token protected route), do not apply this auth flow
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const authenticationService: AuthenticationService = inject(AuthenticationService);

  // Use the async method to get the access token and handle the Promise properly
  const toastr = inject(ToastrService);
  return from(authenticationService.getAccessTokenAsync()).pipe(
    switchMap((accessToken) => {
      if (accessToken === '') {
        authenticationService.logout();
        toastr.error('Please login again.', 'Session Expired');
        return EMPTY;
      }

      // set content type to json if not already set
      if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
        req = req.clone({
          headers: req.headers.set('Content-Type', 'application/json')
        });
      }

      // add the accessToken to request parameters for authentication with our back end api
      req = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + accessToken),
        withCredentials: true
      });

      return next(req);
    })
  );
};
